// extracted by mini-css-extract-plugin
module.exports = {"section":"V5wi9UYiDQfnky8DX0Xl"};